import moment from 'moment';
import { dateTimeFormats } from '@shared/constants/dateTimeFormats';
import { PlatformUser } from '@/app/platform/platform-core/user/models/platform-user';

function formatTimestamp(value: string | null | undefined): string {
  return value ? moment(value).format(dateTimeFormats.standard) : '—';
}

/**
 * Read-only weergavemodel van de accountgegevens in de "Mijn instellingen"-
 * dialoog. De datums zijn voorgeformatteerde strings; de labels worden in de
 * container vertaald (zie `account.settings.fields.*`).
 */
export class AccountDetails {
  constructor(
    public userName: string,
    public displayName: string,
    public firstName: string,
    public lastName: string,
    public email: string,
    public createdOn: string,
    public lastModifiedOn: string
  ) {}

  static fromUser(user: PlatformUser): AccountDetails {
    return new AccountDetails(
      user.userName ?? '',
      user.displayName ?? '',
      user.firstName ?? '',
      user.lastName ?? '',
      user.email ?? '',
      formatTimestamp(user.createdOn),
      formatTimestamp(user.lastModifiedOn)
    );
  }
}
